module.exports = __webpack_public_path__ + "img/7.17c3bc3b.svg";